import TimeRestrictedContent from './TimeRestrictedContent';

export default TimeRestrictedContent;
